import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      gcTime: 5 * 60 * 1000, // 5 minutes (replaces cacheTime)
    },
  },
});

export default queryClient;
